import React from "react";
import Icon, { IconProps } from "./Icon";

/**
 * Download icon for file export and retrieval actions.
 */
export const DownloadIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path d="M12 3v11" />
      <path d="m7 10 5 5 5-5" />
      <path d="M5 21h14" />
    </Icon>
  );
};

export default DownloadIcon;
